module.exports = __webpack_public_path__ + "img/NoPath1.1ada4e86.png";